import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f261e9b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rewards f-scroll" }
const _hoisted_2 = { class: "rewards-head" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("本月")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上月")
const _hoisted_5 = { class: "rewards-neck" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-info" }, "*單位：新台幣", -1))
const _hoisted_7 = { class: "rewards-total" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rewards-total-text" }, "本月總額", -1))
const _hoisted_9 = { class: "rewards-total-amount" }
const _hoisted_10 = { class: "rewards-jobs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rollback_outlined = _resolveComponent("rollback-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_JobListItemReward = _resolveComponent("JobListItemReward")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'MyReward' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "back-btn",
            type: "text"
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_rollback_outlined)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        class: "rewards-filter-button",
        shape: "round",
        type: _ctx.isThisMonth ? 'primary' : '',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setRange('thisMonth')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_a_button, {
        class: "rewards-filter-button",
        shape: "round",
        type: _ctx.isLastMonth ? 'primary' : '',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setRange('lastMonth')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_a_date_picker, {
        class: "rewards-month",
        picker: "month",
        value: _ctx.searchForm.range,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.range) = $event)),
        onChange: _ctx.setRange,
        "allow-clear": false
      }, null, 8, ["value", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, " $" + _toDisplayString(_ctx.rewardsSelectedMonth.totalReward.toLocaleString()), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalJobs, (job) => {
        return (_openBlock(), _createBlock(_component_JobListItemReward, {
          job: job,
          "personal-job-type": _ctx.personJobType,
          key: job.id
        }, null, 8, ["job", "personal-job-type"]))
      }), 128))
    ])
  ]))
}